﻿{
  "community": {
    "name": "Fællesskab",
    "titles": {
      "1": "Onlinefællesskab",
      "2": "Find materialer",
      "3": "Del dit arbejde"
    },
    "body": {
      "1": "Et godt sted til at se alle funktioner i Boardmaker",
      "2": "Se andres arbejde og delinger. Det er ligesom et magisk Boardmaker-vindue!",
      "3": "Overfør, og del dit arbejde med fællesskabet med din foretrukne Boardmaker-software"
    }
  },
  "personal": {
    "name": "Personligt abonnement",
    "header": "Omfatter alt i fællesskabet plus:",
    "titles": {
      "1": "Opret, redigér, afspil og print",
      "2": "Boardmaker-software"
    },
    "body": {
      "1": "Til en forælder eller hjælper med et barn, der gerne vil oprette, redigere, afspille og printe aktiviteter",
      "2": "En konto kommer med en licens til Boardmaker 7, der kan installeres på op til 2 computere med Windows"
    }
  },
  "professional": {
    "name": "Professionelt abonnement",
    "header": "Omfatter alt i det personlige abonnement plus:",
    "titles": {
      "1": "Elevadministration",
      "2": "Individualiserede indstillinger"
    },
    "body": {
      "1": "Til undervisere med 1-50 elever, der gerne vil tildele opgaver og registrere elevdata",
      "2": "Tilpassede adgangsindstillinger for individuelle elever"
    }
  },
  "organization": {
    "name": "Organisationsabonnement",
    "header": "Omfatter alt i det professionelle abonnement plus:",
    "titles": {
      "1": "Tværfaglig teamsupport"
    },
    "body": {
      "1": "Mængderabat. Organisationen kontrollerer oplysningerne, og flere personer kan tildele opgaver til de samme elever"
    }
  }
}
